import { $apiV5 } from "@plugins/axios";
const API = {
  leaderboard: {
    trending: "/leaderboards/trending",
    top: "/leaderboards/top",
    battle: "/leaderboards/battle",
    points: "/leaderboards/points",
  },
  battles: {
    userReward: "/battles/reward/user-rewards",
    seasonStats: "/battles/season-stats",
  },
};

export const getTrendingLeaderboard = async () => {
  try {
    const { data } = await $apiV5.get(API.leaderboard.trending);

    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};

export const getTopLeaderboard = async (params) => {
  try {
    const { data } = await $apiV5.get(API.leaderboard.top, { params });
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};
export const getBattleLeaderboard = async (params) => {
  try {
    const { data } = await $apiV5.get(API.leaderboard.battle, { params });
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};
export const getPointsLeaderboard = async (params) => {
  try {
    const { data } = await $apiV5.get(API.leaderboard.points, { params });
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};

export const getUserBattleRewards = async (params) => {
  try {
    const { data } = await $apiV5.get(API.battles.userReward, { params });
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};

export const getBattleSeasonStats = async () => {
  try {
    const { data } = await $apiV5.get(API.battles.seasonStats);
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};
